<div class="company-selection-page">
  @if (tenantGateStatus === 'loading') {
  <app-loader></app-loader>
  } @else if (showTenantGate) {
  <div class="tenant-gate-shell">
    <div class="tenant-gate-card" [class.rejected]="tenantGateStatus === 'rejected'">
      <div class="brand-mark">
        <i class="fa-solid fa-layer-group"></i>
      </div>
      <span class="tenant-gate-icon" [class.rejected]="tenantGateStatus === 'rejected'">
        <i class="fa-solid" [ngClass]="tenantGateStatus === 'rejected' ? 'fa-circle-xmark' : 'fa-hourglass-half'"></i>
      </span>
      <h1>{{ tenantGateTitle }}</h1>
      <p>{{ tenantGateMessage }}</p>
      <button type="button" class="back-to-login" (click)="backToLogin()">
        <i class="fa-solid fa-arrow-left"></i>
        Back to Login
      </button>
    </div>
  </div>
  } @else {
  <div class="company-selection-shell">
    <aside class="company-context">
      <div class="brand-mark">
        <i class="fa-solid fa-layer-group"></i>
      </div>

      <div class="company-selection-heading">
        <p class="eyebrow">Company Access</p>
        <h1>Select Company</h1>
        <p>Choose the workspace for this session.</p>
      </div>

      <div class="session-card">
        <span class="session-label">Signed in as</span>
        <strong>{{ userInfo?.main?.first_name || userInfo?.main?.username || userInfo?.main?.email }}</strong>
        <span>{{ userInfo?.main?.email }}</span>
      </div>

      <div class="company-stats" [class.single]="isSelectionPending">
        <div>
          <strong>{{ companies.length }}</strong>
          <span>Companies</span>
        </div>
        @if (!isSelectionPending) {
        <div>
          <strong>{{ currentCompany?.code || '-' }}</strong>
          <span>Current</span>
        </div>
        }
      </div>

      <button type="button" class="back-to-login" (click)="backToLogin()">
        <i class="fa-solid fa-arrow-left"></i>
        Back to Login
      </button>
    </aside>

    <section class="company-panel">
      <div class="company-panel-header">
        <div>
          <h2>Available Companies</h2>
          <p>{{ filteredCompanies.length }} of {{ companies.length }} shown</p>
        </div>

        <label class="company-search">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="search" name="companySearch" [(ngModel)]="searchTerm" autocomplete="off" placeholder="Search company or code" />
          @if (hasSearch) {
          <button type="button" class="search-clear" aria-label="Clear search" (click)="clearSearch()">
            <i class="fa-solid fa-xmark"></i>
          </button>
          }
        </label>
      </div>

      <div class="company-grid">
        @for (group of groupedFilteredCompanies; track group.tenantKey; let groupIndex = $index) {
        <section class="tenant-group" [ngClass]="tenantGroupClass(groupIndex)">
          <div class="tenant-group-header">
            <div class="tenant-group-title">
              <span class="tenant-dot" aria-hidden="true"></span>
              <strong>{{ group.tenantLabel }}</strong>
            </div>
            @if (canAddCompany) {
            <button type="button" class="add-company-trigger" (click)="openAddCompanyModal()">
              <i class="fa-solid fa-plus"></i>
              Add Company
            </button>
            }
          </div>

          <div class="tenant-company-list">
            @for (company of group.companies; track company.id) {
            <button
              type="button"
              class="company-option"
              [class.active]="company.id === selectedCompanyId"
              [class.current]="!isSelectionPending && company.id === currentCompanyId"
              [disabled]="loadingCompanyId !== 0"
              (click)="selectCompany(company)"
            >
              <span class="company-icon" aria-hidden="true">
                {{ companyInitials(company) }}
              </span>

              <span class="company-copy">
                <span class="company-row">
                  <span class="company-name">{{ company.name }}</span>
                  @if (!isSelectionPending && company.id === currentCompanyId) {
                  <span class="company-badge">Current</span>
                  } @if (company.is_primary) {
                  <span class="company-badge muted">Primary</span>
                  }
                </span>
                <span class="company-meta">
                  <span>{{ company.code || 'Company' }}</span>
                  @if (companyTenantLabel(company)) {
                  <span>{{ companyTenantLabel(company) }}</span>
                  }
                </span>
              </span>

              @if (loadingCompanyId === company.id) {
              <span class="company-spinner"></span>
              } @else if (company.id === selectedCompanyId) {
              <span class="company-check">
                <i class="fa-solid fa-check"></i>
              </span>
              } @else {
              <i class="fa-solid fa-arrow-right company-arrow"></i>
              }
            </button>
            }
          </div>
        </section>
        } @empty {
        <div class="empty-state">
          <i class="fa-regular fa-building"></i>
          <strong>No companies found</strong>
          <span>Try a different company name or code.</span>
        </div>
        }
      </div>
    </section>
  </div>

  @if (showAddCompanyModal) {
  <div class="add-company-overlay" (click)="closeAddCompanyModal()">
    <div class="add-company-dialog" (click)="$event.stopPropagation()">
      <div class="add-company-header">
        <div>
          <h2>Add Company</h2>
          <p>Create another company under your current tenant.</p>
        </div>
        <button type="button" class="add-company-close" aria-label="Close" [disabled]="isAddingCompany" (click)="closeAddCompanyModal()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <form class="add-company-body" [class.currency-picker-open]="showCurrencyPicker" [formGroup]="addCompanyForm" (ngSubmit)="submitAddCompany()">
        <div class="cs-field-grid">
          <label class="cs-field">
            <span>Company Name <b>*</b></span>
            <input type="text" formControlName="name" class="form-input" placeholder="e.g. RK Distributions" />
            @if (isAddCompanyInvalid('name')) {
            <small>Company name is required.</small>
            }
          </label>

          <label class="cs-field">
            <span>Trade Name</span>
            <input type="text" formControlName="tradeName" class="form-input" placeholder="e.g. RK Trade" />
          </label>

          <label class="cs-field">
            <span>Corporate Email</span>
            <input type="email" formControlName="corporateEmail" class="form-input" placeholder="e.g. corp@rkdist.co" />
            @if (isAddCompanyInvalid('corporateEmail')) {
            <small>Enter a valid corporate email.</small>
            }
          </label>

          <label class="cs-field">
            <span>Tax Registration Number</span>
            <input type="text" formControlName="taxRegistrationNumber" class="form-input" placeholder="e.g. GSTIN91606390" />
          </label>

          <label class="cs-field">
            <span>Registration Number</span>
            <input type="text" formControlName="registrationNumber" class="form-input" placeholder="Company registration number" />
          </label>

          <label class="cs-field">
            <span>Mobile No.</span>
            <input type="tel" formControlName="mobileNo" class="form-input" placeholder="Company mobile number" />
          </label>

          <label class="cs-field">
            <span>Website</span>
            <input type="url" formControlName="website" class="form-input" placeholder="https://example.com" />
          </label>

          <label class="cs-field">
            <span>Country <b>*</b></span>
            <select formControlName="countryId" class="form-input">
              <option [ngValue]="null">Select Country</option>
              @for (country of countries; track country.id) {
              <option [ngValue]="country.id">{{ country.name }}</option>
              }
            </select>
            @if (isAddCompanyInvalid('countryId')) {
            <small>Country is required.</small>
            }
          </label>

          <label class="cs-field">
            <span>Business Type</span>
            <select formControlName="businessTypeId" class="form-input">
              <option [ngValue]="null">Select Business Type</option>
              @for (type of businessTypes; track type.id) {
              <option [ngValue]="type.id">{{ type.name }}</option>
              }
            </select>
          </label>

          <label class="cs-field">
            <span>Employee Size</span>
            <select formControlName="employeeSizeId" class="form-input">
              <option [ngValue]="null">Select Size Range</option>
              @for (size of employeeSizes; track size.id) {
              <option [ngValue]="size.id">{{ size.name }}</option>
              }
            </select>
          </label>

          <label class="cs-field cs-field-logo">
            <span>Logo</span>
            <input type="file" class="sr-only" accept="image/*" (change)="onAddCompanyLogoChange($event)" />
            <span class="cs-logo-box">
              @if (addCompanyLogoPreviewUrl) {
              <img [src]="addCompanyLogoPreviewUrl" alt="Company logo preview" />
              } @else {
              <i class="fa-solid fa-image"></i>
              }
              <span class="cs-logo-copy">
                <strong>{{ addCompanyLogoFileName() || 'Choose logo image' }}</strong>
                <small>PNG, JPG, JPEG, or WebP</small>
              </span>
            </span>
          </label>

          <label class="cs-field cs-field-wide">
            <span>Address</span>
            <textarea rows="2" formControlName="address" class="form-input" placeholder="Company address"></textarea>
          </label>

          <section class="cs-currency-setup cs-field-wide">
            <div class="cs-currency-heading">
              <div>
                <i class="fa-solid fa-coins"></i>
                <strong>Currency Setup</strong>
              </div>
              <small>Choose currencies for this company and select one default.</small>
            </div>

            @if (currencies.length) {
            <div class="cs-currency-layout">
              <div>
                <div class="cs-currency-label">
                  <span>Selected currencies</span>
                  <em>{{ selectedCurrencies.length }} selected</em>
                </div>
                <div class="cs-currency-chips">
                  @for (currency of selectedCurrencies; track currency.id) {
                  <span class="cs-currency-chip">
                    <b>{{ currency.code }}</b>
                    <span>{{ currency.name }}</span>
                    @if (isDefaultCurrency(currency.id)) {
                    <em>Default</em>
                    }
                    <button type="button" title="Remove currency" (click)="removeCurrency(currency.id)">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </span>
                  } @empty {
                  <span class="cs-currency-empty">No currencies selected.</span>
                  }
                </div>

                <div data-currency-picker class="cs-currency-anchor">
                  <button
                    type="button"
                    class="cs-currency-toggle"
                    cdkOverlayOrigin
                    #currencyOverlayOrigin="cdkOverlayOrigin"
                    (click)="toggleCurrencyPicker($event)"
                  >
                    <span><i class="fa-solid fa-coins"></i> Choose currencies</span>
                    <i class="fa-solid fa-chevron-down" [class.rotate-180]="showCurrencyPicker"></i>
                  </button>

                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="currencyOverlayOrigin"
                    [cdkConnectedOverlayOpen]="showCurrencyPicker"
                    [cdkConnectedOverlayPositions]="currencyOverlayPositions"
                    [cdkConnectedOverlayWidth]="currencyOverlayWidth"
                    [cdkConnectedOverlayViewportMargin]="12"
                    [cdkConnectedOverlayPush]="true"
                    [cdkConnectedOverlayHasBackdrop]="true"
                    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                    (backdropClick)="closeCurrencyPicker()"
                    (detach)="closeCurrencyPicker()"
                  >
                    <div data-currency-picker class="cs-currency-picker">
                      <div class="cs-currency-search">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <input
                          type="search"
                          class="form-input"
                          placeholder="Search by code, name, or symbol..."
                          [value]="currencySearch"
                          (input)="currencySearch = $any($event.target).value"
                        />
                      </div>
                      <div class="cs-currency-options">
                        @for (currency of filteredCurrencies; track currency.id) {
                        <label>
                          <input
                            type="checkbox"
                            class="form-checkbox"
                            [checked]="isCurrencySelected(currency.id)"
                            (change)="toggleCurrency(currency.id, $any($event.target).checked)"
                          />
                          <span>
                            <strong>{{ currency.code }}{{ currency.symbol ? ' · ' + currency.symbol : '' }}</strong>
                            <small>{{ currency.name }}</small>
                          </span>
                          @if (isCurrencySelected(currency.id)) {
                          <i class="fa-solid fa-check"></i>
                          }
                        </label>
                        } @empty {
                        <p>No matching currencies found.</p>
                        }
                      </div>
                      <div class="cs-currency-picker-footer">
                        <span>{{ selectedCurrencies.length }} selected</span>
                        <button type="button" (click)="closeCurrencyPicker()">Done</button>
                      </div>
                    </div>
                  </ng-template>
                </div>
                @if (isAddCompanyInvalid('currencyIds')) {
                <small class="cs-currency-error">Select at least one currency.</small>
                }
              </div>

              <label class="cs-field">
                <span>Default Currency <b>*</b></span>
                <select class="form-input" formControlName="defaultCurrencyId" (change)="selectDefaultCurrency($any($event.target).value)">
                  <option value="">Select Default Currency</option>
                  @for (currency of selectedCurrencies; track currency.id) {
                  <option [value]="currency.id">{{ currency.code }} - {{ currency.name }}</option>
                  }
                </select>
                @if (isAddCompanyInvalid('defaultCurrencyId')) {
                <small>Select one default currency.</small>
                } @else {
                <small class="cs-currency-help">The default currency starts with an exchange rate of 1.</small>
                }
              </label>
            </div>
            } @else {
            <p class="cs-currency-unavailable">Currency options are not available. Please try again.</p>
            }
          </section>
        </div>

        @if (addCompanyError) {
        <p class="add-company-error">{{ addCompanyError }}</p>
        }

        <div class="add-company-footer">
          <button type="button" class="add-company-btn secondary" [disabled]="isAddingCompany" (click)="closeAddCompanyModal()">Cancel</button>
          <button type="submit" class="add-company-btn primary" [disabled]="isAddingCompany">
            {{ isAddingCompany ? 'Adding...' : 'Add Company' }}
            <i class="fa-solid" [ngClass]="isAddingCompany ? 'fa-spinner fa-spin' : 'fa-arrow-right'"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
  }
  }
</div>
